<!-- ===================================== -->
<!-- HEADER COMPONENT - MOBILE MENU FIX -->
<!-- ===================================== -->
<template name="Header">
  <div>
    <header :class="['modern-header', { 'scrolled': isScrolled }]">
      <nav class="navbar navbar-expand-lg">
        <div class="container">
          <!-- Brand Logo -->
          <a class="navbar-brand" href="javascript:void(0)" @click="navigateAndClose({ path: '/' })">
            <img src="/images/logo.png" alt="Bee's Atelier" class="logo-image" />
          </a>

          <!-- ✅ Cart icon + Toggler grouped on the right for mobile -->
          <div class="d-flex align-items-center d-lg-none ms-auto gap-3">
            <a class="nav-link cart-link p-0" href="javascript:void(0)" @click="navigateAndClose({ path: '/cart' })">
              <div class="cart-icon-wrapper">
                <i class="fas fa-shopping-bag"></i>
                <span v-if="cartItemsCount > 0" class="cart-badge">{{ cartItemsCount }}</span>
              </div>
            </a>
            <button
              class="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#mainNav"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
          </div>

          <!-- Navbar Links -->
          <div class="collapse navbar-collapse" id="mainNav">
            <ul class="navbar-nav mx-auto">
              <li class="nav-item">
                <a class="nav-link" :class="{ active: isActive('/') }" href="javascript:void(0)" @click="navigateAndClose({ path: '/' })">Home</a>
              </li>
              <li class="nav-item dropdown">
                
                  <a class="nav-link"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  :class="{ active: isActive('/shop') }"
                  ref="shopDropdown"
                >
                  Shop <i class="fas fa-chevron-down ms-1"></i>
                </a>
                <ul class="dropdown-menu modern-dropdown">
                  <li><a class="dropdown-item" href="javascript:void(0)" @click="navigateAndClose({ path: '/shop' })">All Products</a></li>
                  <li><hr class="dropdown-divider"></li>
                  <li v-for="category in categories" :key="category.slug">
                    <a class="dropdown-item" href="javascript:void(0)" @click="navigateAndClose({ name: 'ShopBySlug', params: { slug: category.slug } })">{{ category.title }}</a>
                  </li>
                </ul>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="javascript:void(0)" @click="navigateAndClose({ path: '/workshop' })" :class="{ active: isActive('/workshop') }">Workshops</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="javascript:void(0)" @click="navigateAndClose({ path: '/about' })" :class="{ active: isActive('/about') }">About</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="javascript:void(0)" @click="navigateAndClose({ path: '/contact' })" :class="{ active: isActive('/contact') }">Contact</a>
              </li>
            </ul>

            <!-- ✅ Cart icon inside collapse — desktop only -->
            <ul class="navbar-nav ms-auto d-none d-lg-flex">
              <li class="nav-item">
                <a class="nav-link cart-link" href="javascript:void(0)" @click="navigateAndClose({ path: '/cart' })">
                  <div class="cart-icon-wrapper">
                    <i class="fas fa-shopping-bag"></i>
                    <span v-if="cartItemsCount > 0" class="cart-badge">{{ cartItemsCount }}</span>
                  </div>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </nav>
    </header>
  </div>
</template>
<script>
import ProductService from "../services/ProductService";
import { useToast } from "vue-toast-notification";
const $toast = useToast();
import { EventBus } from '@/eventBus'

export default {
  name: "Header",
  data() {
    return {
      cartItemsCount: 1,
      categories: [],
      isScrolled: false
    };
  },
  methods: {
    getCategories() {
      ProductService.getCategories()
        .then((response) => {
          this.categories = response.data.data;
        })
        .catch((e) => {
          $toast.error(e.response?.data?.response_msg || e.message);
        });
    },
    async getCartCount() {
        await ProductService.getCartCount()
        .then((response) => {
          this.cartItemsCount = response.data.data;
        }).catch((e) => {
          $toast.error(e.response.data.respones_msg);
        });
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },
    isActive(path) {
      return this.$route.path === path;
    },
    closeMobileMenu() {
      // Only close menu on mobile devices
      if (window.innerWidth <= 991) {
        // Close mobile navbar collapse
        const navbarCollapse = document.getElementById('mainNav');
        if (navbarCollapse && navbarCollapse.classList.contains('show')) {
          const bsCollapse = window.bootstrap.Collapse.getInstance(navbarCollapse);
          if (bsCollapse) {
            bsCollapse.hide();
          } else {
            // If instance doesn't exist, create one and hide
            const collapse = new window.bootstrap.Collapse(navbarCollapse, {
              toggle: false
            });
            collapse.hide();
          }
        }
        
        // Also close dropdown if open on mobile
        if (this.$refs.shopDropdown) {
          const dropdown = window.bootstrap.Dropdown.getInstance(this.$refs.shopDropdown);
          if (dropdown) {
            dropdown.hide();
          }
        }
      }
    },
    navigateAndClose(route) {
      // Only add delay on mobile for smooth closing animation
      if (window.innerWidth <= 991) {
        this.closeMobileMenu();
        setTimeout(() => {
          this.$router.push(route);
        }, 100);
      } else {
        // Desktop: navigate immediately without closing anything
        this.$router.push(route);
      }
    },
    showDropdown() {
      // Show dropdown on hover (desktop only)
      if (window.innerWidth > 991 && this.$refs.shopDropdown && typeof window.bootstrap !== 'undefined') {
        const dropdown = new window.bootstrap.Dropdown(this.$refs.shopDropdown);
        dropdown.show();
      }
    },
    hideDropdown() {
      setTimeout(() => {
        if (this.$refs.shopDropdown && window.bootstrap) {
          const dropdown = window.bootstrap.Dropdown.getInstance(this.$refs.shopDropdown);
          if (dropdown) dropdown.hide();
        }
      }, 500);
    }
  },
  watch: {
    '$route'(to, from) {
      this.getCartCount();
    },
  },
  created() {
    this.getCategories();
    this.getCartCount();
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    EventBus.on('cart-updated', () => {
      this.getCartCount()
    })
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped>
/* Modern Header Styles */
.modern-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  /* ✅ FIX: raised from 1000 → 1050 so the expanded mobile menu
     always renders above any page content (filters, cards, etc.)  */
  z-index: 1050;
  background: white;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}

.modern-header.scrolled {
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  padding: 0;
}

.modern-header.scrolled .navbar {
  padding: 8px 0;
}

.navbar {
  padding: 15px 0;
  transition: padding 0.3s ease;
}

.logo-image {
  height: 50px;
  width: auto;
  transition: all 0.3s ease;
  filter: brightness(1) contrast(1.1);
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

.modern-header.scrolled .logo-image {
  height: 40px;
}

.nav-link {
  font-weight: 500;
  font-size: 15px;
  color: #2d3748;
  padding: 8px 16px;
  position: relative;
  transition: color 0.3s;
  display: inline-flex;
  align-items: center;
  outline: none !important;
  box-shadow: none !important;
}

.nav-link:focus {
  outline: none !important;
  box-shadow: none !important;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 2px;
  background: rgb(118, 172, 175);
  transition: width 0.3s;
}

.nav-link:hover::after,
.nav-link.active::after {
  width: 70%;
}

.nav-link:hover,
.nav-link.active {
  color: rgb(118, 172, 175);
}

/* Dropdown arrow - positioned next to Shop text */
.nav-link .fa-chevron-down {
  font-size: 10px;
  transition: transform 0.3s;
  margin-left: 5px;
}

.dropdown:hover .fa-chevron-down,
.dropdown.show .fa-chevron-down {
  transform: rotate(180deg);
}

/* Remove Bootstrap's default focus styles */
.dropdown-toggle:focus,
.dropdown-toggle:active,
.dropdown-toggle.show {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}

/* Remove the blue box around dropdown */
.nav-item.dropdown .nav-link:focus,
.nav-item.dropdown .nav-link:active,
.nav-item.dropdown .nav-link.show {
  outline: none !important;
  box-shadow: none !important;
  background-color: transparent !important;
}

.modern-dropdown {
  border: none;
  box-shadow: 0 8px 30px rgba(0,0,0,0.12);
  border-radius: 12px;
  padding: 10px;
  margin-top: 10px;
}

.dropdown-item {
  padding: 10px 16px;
  border-radius: 8px;
  transition: all 0.3s;
}

.dropdown-item:hover {
  background: rgba(118, 172, 175, 0.1);
  color: rgb(118, 172, 175);
  transform: translateX(5px);
}

.cart-icon-wrapper {
  position: relative;
  display: inline-block;
  padding: 8px 12px;
  background: linear-gradient(135deg, rgb(118, 172, 175), rgb(98, 152, 155));
  border-radius: 50px;
  transition: all 0.3s;
}

.cart-icon-wrapper:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 15px rgba(118, 172, 175, 0.4);
}

.cart-icon-wrapper i {
  color: white;
  font-size: 18px;
}

.cart-badge {
  position: absolute;
  top: -10px;
  right: -10px;
  background: #f93a5a;
  color: white;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 7px;
  border-radius: 50%;
  min-width: 20px;
  text-align: center;
  border: 2px solid white;
}

/* Mobile responsive */
@media (max-width: 991px) {
  .nav-link {
    padding: 12px 16px;
  }

  /* ✅ FIX: expanded mobile menu gets its own white background and
     sits above ALL page content — no more bleed-through from cards/filters */
  #mainNav.show,
  #mainNav.collapsing {
    position: relative;
    z-index: 1050;
    background: white;
    border-top: 1px solid #f0f0f0;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.10);
    padding: 8px 0 16px;
  }

  .modern-dropdown {
    box-shadow: none;
    border: 1px solid #e2e8f0;
  }
  
  /* Ensure smooth closing animation on mobile */
  .navbar-collapse.collapsing {
    transition: height 0.3s ease;
  }
}

/* Desktop hover dropdown */
@media (min-width: 992px) {
  .nav-item.dropdown:hover > .dropdown-menu {
    display: block;
    margin-top: 0;
  }
}

</style>